import { render, staticRenderFns } from "./ConsumeListDialog.vue?vue&type=template&id=d5b70054&scoped=true"
import script from "./ConsumeListDialog.vue?vue&type=script&lang=js"
export * from "./ConsumeListDialog.vue?vue&type=script&lang=js"
import style0 from "./ConsumeListDialog.vue?vue&type=style&index=0&id=d5b70054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b70054",
  null
  
)

export default component.exports